import axios from 'axios'
const API_URL = process.env.REACT_APP_API_URL

export function getDevices(Subscription: number, cloud?: any, region?: any) {
  return axios.get(API_URL + '/v1/ctxr/' + Subscription + '/list', { params: { cloud, region } })
}
export function getDevicesListglobal(Subscription: number, tenant: number, cloud?: any, region?: any) {
  return axios.get(API_URL + '/v1/ctxr/' + Subscription + '/list?tenantId=' + tenant, { params: { cloud, region } })
}
export function getpermisosDisponibles() {
  return axios.get(API_URL + '/v1/permission')
}
export function getpermisosDisponiblesGlobal(tenant: number) {
  return axios.get(API_URL + '/v1/permission?tenantId=' + tenant)
}
export function getPermisoId(id: any) {
  return axios.get(API_URL + '/v1/rol/' + id)
}
export function getPermisoIdGlobal(id: any, tenant: number) {
  return axios.get(API_URL + '/v1/rol/' + id + '?tenantId=' + tenant)
}
export function getroles() {
  return axios.get(API_URL + '/v1/rol/')
}

export function getsuscriptions() {
  return axios.get(API_URL + '/v1/suscription')
}
export function getsuscriptionsglobal(id: any) {
  return axios.get(API_URL + '/v1/suscription?tenantId=' + id)
}

export function getDeviceId(Subscription: any, id: any) {
  return axios.get(API_URL + '/v1/ctxr/' + Subscription + '/' + id)
}

export function getDeviceIdtenant(Subscription: any, id: any, tenant: any) {
  return axios.get(API_URL + '/v1/ctxr/' + Subscription + '/' + id + '?tenantId=' + tenant)
}


export function getDevicesUnlicenced(Subscription: number, cloud?: any, region?: any) {
  return axios.get(API_URL + '/v1/ctxr/' + Subscription + '/listUnlicensed', { params: { cloud, region } })
}
export function getDevicesUnlicencedglobal(Subscription: number, tenant: number, cloud?: any, region?: any) {
  return axios.get(API_URL + '/v1/ctxr/' + Subscription + '/listUnlicensed?tenantId=' + tenant, { params: { cloud, region } })
}

export function getdevicesungroup(Subscription: number) {
  return axios.get(API_URL + '/v1/ctxr/' + Subscription + '/listSelectorWithoutCluster')
}
export function getdevicesungrouptenant(Subscription: number, tenant: number) {
  return axios.get(API_URL + '/v1/ctxr/' + Subscription + '/listSelectorWithoutCluster?tenantId=' + tenant)
}

export function getclusters(Subscription: number, cloud?: any, region?: any) {
  return axios.get(API_URL + '/v1/ClusterCtxr/' + Subscription + '/list', { params: { cloud, region } })
}

export function getclustersglobal(Subscription: number, tenant: number, cloud?: any, region?: any) {
  return axios.get(API_URL + '/v1/ClusterCtxr/' + Subscription + '/list?tenantId=' + tenant, { params: { cloud, region } })

}

export function getclustersbyId(Subscription: number, cloud?: any, region?: any) {
  return axios.get(API_URL + '/v1/ClusterCtxr/' + Subscription + '/list', { params: { cloud, region } })
}

export function getclustersglobalbyId(Subscription: number, tenant: number, cloud?: any, region?: any) {
  return axios.get(API_URL + '/v1/ClusterCtxr/' + Subscription + '/list?tenantId=' + tenant, { params: { cloud, region } })

}

export function getclustersG(Subscription: number) {
  return axios.get(API_URL + '/v1/ClusterCtxr/' + Subscription + '/list')
}

export function getclustersglobalG(Subscription: number, tenant: number) {
  return axios.get(API_URL + '/v1/ClusterCtxr/' + Subscription + '/list?tenantId=' + tenant)

}

export function deleteclusters(Subscription: number, clusterid: number) {
  return axios.delete(API_URL + '/v1/ClusterCtxr/' + Subscription + '/' + clusterid)
}

export function deleteclustersglobal(Subscription: number, clusterid: number, tenant: number) {
  return axios.delete(API_URL + '/v1/ClusterCtxr/' + Subscription + '/' + clusterid + '?tenantId=' + tenant)

}

export function getclusterbyid(Subscription: number, clusterid: number) {
  return axios.get(API_URL + '/v1/ClusterCtxr/' + Subscription + '/' + clusterid)
}

export function getclusterbyidtenant(Subscription: number, clusterid: number, tenant: number) {
  return axios.get(API_URL + '/v1/ClusterCtxr/' + Subscription + '/' + clusterid + '?tenantId=' + tenant)

}

export function getips(uuid: any) {
  return axios.get(API_URL + '/v1/ctxr/listcni/' + uuid)
}
export function getipstenant(uuid: any, tenant: number) {
  return axios.get(API_URL + '/v1/ctxr/listcni/' + uuid + '?tenantId=' + tenant)
}

export function getListSelectorWithoutCluster(subscriptionid: number, tenantId: number, cloud: string, region?: string) {
  return axios.get(`${API_URL}/v1/ctxr/${subscriptionid}/listSelector`, {
    params: {
      tenantId,
      cloud,
      region
    }
  });
}

export function getHealthCheck(subscriptionId: number, tenantId: number, cloud: string, region: string) {
  return axios.get(`${API_URL}/v1/ctxr/${subscriptionId}/healthcheck`, {
    params: {
      tenantId,
      cloud,
      region,
    },
  });
}

export function getCloudConnection(subscriptionId: number, tenantId: number) {
  return axios.get(`${API_URL}/v1/ctxr/${subscriptionId}/healthcheck`, {
    params: {
      tenantId,
    },
  });
}

export function getHealthCheckDetails(subscriptionId: number, uuid: any, tenantId: number, startDate: string, endDate: string, limit: number) {
  return axios.get(`${API_URL}/v1/ctxr/${subscriptionId}/healthcheck/${uuid}`, {
    params: {
      tenantId,
      limit,
      start_date: startDate,
      end_date: endDate,
    },
  });
}
export function getAvailableServers(subscriptionId: number, uuid: string, tenantId: number) {
  return axios.get(`${API_URL}/v1/serverlog/${subscriptionId}/available/${uuid}`, {
    params: { tenantId }
  });
}

export function getSelectedServers(subscriptionId: number, uuid: string, tenantId: number) {
  return axios.get(`${API_URL}/v1/serverlog/${subscriptionId}/ctxr/${uuid}`, {
    params: { tenantId }
  });
}

export function createAssociationWithSyslog(
  uuid: string,
  data: { id: number, level: number }[],
  tenantId: number
) {
  return axios.post(`${API_URL}/v1/ctxr/associationwithsyslog/${uuid}`, data, {
    params: {
      tenantId: tenantId,
    },
  });
}